import React, { Fragment, useState } from "react";
import { DatePicker, TimePicker } from "antd";
import moment from "moment";
import errorIcon from "../../assets/img/ci_warning.png";
import "./TimeSheet.css";

const TimeSheetShift = ({ label, selectedTime, handleTimeChange,disabled=false }) => {
  return (
    <Fragment>
      <div className="email-text">
        {label}
        <div className="email-mandatory">(Mandatory)</div>
      </div>
      <TimePicker
        disabled={disabled}
        value={selectedTime}
        autoFocus
        allowClear={false}
        className="time-shift-time-picker"
        use12Hours
        format="h:mm a"
        onChange={handleTimeChange}
        placeholder=""
      />
      {/* {showError && (
        <div className="error-msg-content">
          <img src={errorIcon} alt="Error icon" />
          <span className="error-text">
            Please enter your start date to continue
          </span>
        </div>
      )} */}
    </Fragment>
  );
};

export default TimeSheetShift;
